// 기기 데이터 관련 상수들
import { UNIFIED_DEVICE_DATA } from '../../../../constants/unifiedDeviceData';

// 태블릿 카탈로그
export const TABLET_CATALOG = UNIFIED_DEVICE_DATA.filter(d => d.category === '태블릿');

// 단계 정의 함수
// - 스마트폰: 카테고리 → 제조사 → 시리즈 → 모델 → 구성(용량) → 등급
// - 태블릿:   카테고리 → 제조사 → 모델 → 구성(용량) → 등급 선택
// - 웨어러블: 카테고리 → 모델 → 구성 → 등급
export const getStepsByCategory = (category: string) => {
  if (category === '스마트폰') {
    return ['카테고리 선택', '제조사 선택', '시리즈 선택', '모델 선택', '구성 선택', '등급 선택'];
  } else if (category === '태블릿') {
    return ['카테고리 선택', '제조사 선택', '모델 선택', '구성 선택', '등급 선택'];
  } else {
    return ['카테고리 선택', '모델 선택', '구성 선택', '등급 선택'];
  }
};

/**
 * 🎯 시세 조회용 단계 정의 함수
 * - 기존 프로세스에서 "등급 선택" 단계를 "시세 확인"으로 변경
 * - 마지막 단계에서 등급 선택 대신 모든 등급별 가격 표시
 * - 웨어러블도 시세 확인 단계 추가 (스마트폰/태블릿과 동일한 UX)
 */
export const getPriceQuoteStepsByCategory = (category: string) => {
  if (category === '스마트폰') {
    return ['카테고리 선택', '제조사 선택', '시리즈 선택', '모델 선택', '구성 선택', '시세 확인'];
  } else if (category === '태블릿') {
    return ['카테고리 선택', '제조사 선택', '모델 선택', '구성 선택', '시세 확인'];
  } else if (category === '웨어러블') {
    // 🎯 웨어러블도 시세 확인 단계 추가
    return ['카테고리 선택', '모델 선택', '구성 선택', '시세 확인'];
  } else {
    return ['카테고리 선택', '모델 선택', '구성 선택'];
  }
};

// 동적으로 생성되는 상수들의 타입 정의 (나중에 훅으로 이동될 예정)
export type IPhoneSeriesModels = Record<string, string[]>;
export type IPhoneStorageByModel = Record<string, string[]>;
export type IPhoneThumbnails = Record<string, string>;

// Samsung 시리즈 데이터 타입
export interface SamsungSeriesData {
  name: string;
  models: Array<{
    name: string;
    name_ko: string;
    storages: string[];
    release_year?: number;
  }>;
}

// Device Models 타입 (나중에 훅으로 이동될 예정)
export interface DeviceModelsData {
  '스마트폰': any[];
  '태블릿': any[];
  '웨어러블': any[];
}
